import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const CreateNewPermission = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    permission_name: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/admin/permissions`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authentication/token")}` },
      });
      Swal.fire("Success!", "Permission created successfully.", "success");
      navigate("/permissions");
    } catch (error) {
      Swal.fire("Error!", "Failed to create permission.", "error");
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <h2 className="text-lg font-semibold mb-4">Create New Permission</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Permission Name</label>
          <input type="text" name="permission_name" value={formData.permission_name} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" required />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea name="description" value={formData.description} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"></textarea>
        </div>
        <div className="flex justify-end space-x-2">
          <button type="button" onClick={() => navigate("/permissions")} className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">
            Back
          </button>
          <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateNewPermission;